import React from 'react';
import styled from 'styled-components';
import { NavItem } from '@shared/interfaces/navigate';

type SocialProps = {
  ariaLabel: string;
  links: NavItem[];
  margin?: string;
};

function Social({ ariaLabel, links, margin }: SocialProps) {
  return (
    <SocialNav aria-label={ariaLabel} $margin={margin}>
      <StyledUl>
        {links.map(({ href, ariaLabel, Icon, target }) => (
          <li key={href}>
            <a href={href} aria-label={ariaLabel} target={target}>
              <IconWrapper>{Icon && <Icon />}</IconWrapper>
            </a>
          </li>
        ))}
      </StyledUl>
    </SocialNav>
  );
}

const SocialNav = styled.nav<{ $margin?: string }>`
  min-width: 224px;

  margin: ${({ $margin }) => $margin};

  display: flex;
  justify-content: center;
  align-items: center;
`;

const IconWrapper = styled.div`
  height: 24px;
  width: 24px;
  margin: 10px;

  display: flex;
  justify-content: center;
  align-items: center;

  cursor: pointer;
`;

const StyledUl = styled.ul`
  display: flex;
  align-items: center;
`;

export default Social;
